import { render, staticRenderFns } from "./PLIFarmacias.vue?vue&type=template&id=3f993a4e&scoped=true&"
import script from "./PLIFarmacias.vue?vue&type=script&lang=js&"
export * from "./PLIFarmacias.vue?vue&type=script&lang=js&"
import style0 from "./PLIFarmacias.vue?vue&type=style&index=0&id=3f993a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f993a4e",
  null
  
)

export default component.exports